/* eslint-disable react/no-unused-prop-types */
import React, { useCallback, useRef, useState } from 'react';
import { Chip } from 'design-system/Chip';
import { FlatList, StyleSheet, } from 'react-native';
import { last } from 'lodash';
import { rem } from 'design-system/values';
export const useChipGroup = (selectedChipsInitialValue = [], multiselect = true) => {
    const [selectedChips, setSelectedChips] = useState(selectedChipsInitialValue);
    const toggleChip = useCallback((chip) => {
        if (!multiselect) {
            setSelectedChips([chip]);
            return;
        }
        const chipInArray = selectedChips.find((c) => c.id === chip.id);
        if (chipInArray) {
            setSelectedChips(selectedChips.filter((c) => c.id !== chip.id));
        }
        else {
            setSelectedChips([...selectedChips, chip]);
        }
    }, [multiselect, selectedChips]);
    return { toggleChip, selectedChips, setSelectedChips };
};
export const ChipGroup = React.memo(React.forwardRef(({ chips, chipType, chipStyle, selectedChips = [], style, onChipSelect, onItemsLayout, onLight, ...props }, ref) => {
    const checkSelected = (chip) => Boolean(selectedChips.find((c) => c.id === chip.id));
    const chipWidths = useRef({});
    const onAddWidth = useCallback((index, width) => {
        chipWidths.current[index] = width;
        if (Object.keys(chipWidths.current).length === chips.length) {
            const offsets = Object.values(chipWidths.current).reduce((prV, _cV, i) => {
                const lastOffset = last(prV) || 0;
                const lastWidth = chipWidths.current[i - 1] || 0;
                return [...prV, lastOffset + lastWidth];
            }, []);
            onItemsLayout?.(offsets);
        }
    }, [chips.length, onItemsLayout]);
    return (<FlatList contentContainerStyle={style} data={chips} ref={ref} horizontal keyboardShouldPersistTaps="always" showsHorizontalScrollIndicator={false} renderItem={({ item, index }) => (<Chip onLayout={(event) => {
                const { width } = event.nativeEvent.layout;
                onAddWidth(index, width);
            }} key={item.id} icon={item.icon} text={item.text} type={chipType} style={[chipStyle, index === 0 && styles.firstChip]} onPress={() => {
                onChipSelect?.(item, index);
            }} Brand={checkSelected(item)} Dark={onLight} containerStyle={props.chipContainerStyle}/>)} scrollEventThrottle={16} {...props}/>);
}));
const styles = StyleSheet.create({
    firstChip: {
        marginLeft: rem(8),
    },
});
